// extracted by mini-css-extract-plugin
export default {"globalFonts":"breakpoints_globalFonts__xTQOa"};